import { Product } from "../../../../../models/models";
import { StoreItemsArticle } from "../../storeItemsArticle";

export function StoreItems (product: Product, productsSameType: Product[]) {
  return <StoreItemsArticle product={product} productsSameType={productsSameType} key={`${product.code}-${product.stockRatio}`}></StoreItemsArticle>;
}